import {
  first,
  merge,
  Observable,
  shareReplay,
  Subject,
} from 'rxjs';

import {
  SlideDirection,
  Story,
  StorySlide,
  StorySlideIndexed,
} from './stories.entities';
import { StoryItem } from './story-item';

export class StoriesList {

	public slideChange$: Observable<StorySlideIndexed>;

	public _stories: Array<StoryItem> = [];
	private curStoryIndex: number = 0;
	private curSlideIndex: number = 0;

	private isFinished$$: Subject<void> = new Subject();

	private storyChange$$: Subject<Story> = new Subject();
	// eslint-disable-next-line @typescript-eslint/member-ordering
	public storyChange$: Observable<Story> = this.storyChange$$.asObservable();


	constructor(stories: Array<Story>) {
		const slideChanges: Array<Observable<StorySlideIndexed>> = [];

		stories.forEach((story: Story) => {
			const storyItem = new StoryItem(story);
			this._stories.push(storyItem);
			slideChanges.push(storyItem.slideChange$)

			storyItem.isFinished$.subscribe((dir: SlideDirection) => {
				//console.log('%conFinished', 'font-size:40px');
				if (dir === 1) {
					this.playNextStory();
				} else {
					this.playPrevStory();
				}
			});
		});

		this.slideChange$ = merge(...slideChanges).pipe(shareReplay(1));
	}

	public get stories(): Array<StoryItem> {
		return this._stories;
	}

	public get story(): Story {
		return this.storyItem.story;
	}

	public get slide(): StorySlide | undefined {
		return this.story.slides?.[this.curSlideIndex];
	}

	public get slideIndex(): number {
		return this.curSlideIndex;
	}

	public get storyItem(): StoryItem {
		return this._stories[this.curStoryIndex];
	}

	public stop(unSubscribe: boolean = false): void {
		//console.log('%cList stop story: ' + this.curStoryIndex, 'color: blue');
		this.curStoryIndex = 0;
		this._stories.forEach((story: StoryItem) => {
			story.stop();
			story.resetOnFirstSlide();
			if (unSubscribe) {
				story.complete();
			}
		});
	}

	public play(storyIndex: number | null): StoriesList {
		//console.log('%c______play_____: ' + storyIndex, 'color: green');

		if (storyIndex !== null) {
			this.curStoryIndex = storyIndex;

			this._stories[this.curStoryIndex - 1]?.stop();
			//this.stories.forEach((story: StoryItem) => story.stop());
			this.storyItem.play();
			this.storyChange$$.next(this.storyItem.story);
		} else {
			//console.log('%c____________________->| no more stories', 'color: blue');
			this.isFinished$$.next();
		}

		return this;
	}

	public playNextStory(): void {
		const newIndex = this.nextStory();
		this.stop();
		this.play(newIndex);
	}

	public playPrevStory(): void {
		const newIndex = this.prevStory();
		this.stop();
		this.play(newIndex);
	}

	public nextStory(): number | null {
		this.curSlideIndex = -1;

		if (this.curStoryIndex < this._stories.length - 1) {
			return ++this.curStoryIndex;
		}

		return null;
	}

	public prevStory(): number | null {
		this.curSlideIndex = -1;

		if (this.curStoryIndex > 0) {
			return --this.curStoryIndex;
		}

		return null;
	}

	public next(): void {
		//console.log('%cStoriesList.next: ' + this.storyItem.slide?.index + ' -> ' + (this.storyItem.slide?.index + 1), 'color: navy; font-weight: bold; font-size:20px;');
		this.storyItem.stop().next()
			.playCurrent();
	}

	public prev(): void {
		//console.log('%cStoriesList.prev: ' + (this.storyItem.slide?.index - 1) + ' <- ' + (this.storyItem.slide?.index), 'color: dodgerblue; font-weight: bold; font-size:20px;');
		this.storyItem.stop().prev()
			.playCurrent();
	}

	public onFinished(cb: () => void): void {
		this.isFinished$$.asObservable()
			.pipe(
				first(),
			)
			.subscribe(() => cb());
	}

}